<form [formGroup]="speciesForm" class="w-100">

    <mat-form-field class="w-100">
        <mat-label>{{'FORM.gameRecordForm.wildart' | translate}}</mat-label>
        <mat-select formControlName="wildart">
            <mat-option *ngFor="let sp of species" [value]="sp.identifier">{{sp.names.de}}</mat-option>
        </mat-select>
    </mat-form-field>

    <div [hidden]="!diplayGenderSelect">
        <div class="row justify-content-between">
            <div class="col">
                {{'FORM.personForm.geschlecht' | translate}}
            </div>
            <div class="col">
                <mat-radio-group formControlName="gender" aria-label="Select an option">
                    <mat-radio-button value="M">{{'FORM.personForm.genderMale' | translate}}</mat-radio-button>
                    <mat-radio-button value="F">{{'FORM.personForm.genderFemale' | translate}}</mat-radio-button>
                    <mat-radio-button [value]="genderUnknownValue" *ngIf="hasUnknownGenderOption()">{{'FORM.personForm.genderUnknown' | translate}}</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>
    </div>
    <div *ngIf="ageClassesSubject$ | async as ages">
        <div *ngIf="ages != undefined">
            <mat-form-field class="w-100">
                <mat-label>{{'FORM.gameRecordForm.age' | translate}}</mat-label>
                <mat-select formControlName="age">
                    <mat-option *ngFor="let el of ages" [value]="el">{{el}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <button [disabled]="formInvalid" class="spanw w-100" mat-raised-button color="primary"
            type="submit" (click)="onSubmit()">
            {{ 'FORM.BTN_SET' | translate }}
    </button>
</form>
